(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["petbar-header-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  const selections = new Map();
  const cardKey = card => card.querySelector('a[href]')?.getAttribute('href') || '';
  const repairMenu = menu => {
    if (menu.hasAttribute('data-pb-categories')) return;
    const grid = menu.querySelector('.pb-mega-products__grid');
    if (!grid || !grid.children.length) return;
    const cards = Array.from(grid.children);
    const key = menu.querySelector('.pb-mega-products__all')?.getAttribute('href') || menu.getAttribute('data-menu-list-id');
    const pool = cards.map(cardKey);
    const poolKey = [...pool].sort().join('|');
    let selection = selections.get(key);
    if (!selection || selection.poolKey !== poolKey) {
      const order = [...pool];
      for (let i = order.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [order[i], order[j]] = [order[j], order[i]];
      }
      selection = {poolKey, ranks: new Map(order.map((url, index) => [url, index]))};
      selections.set(key, selection);
    }
    const desired = [...cards].sort((a, b) => selection.ranks.get(cardKey(a)) - selection.ranks.get(cardKey(b)));
    const moved = desired.some((card, index) => card !== cards[index]);
    desired.forEach((card, index) => {
      const hidden = index >= 24;
      if (card.hidden !== hidden) card.hidden = hidden;
    });
    if (moved) {
      const fragment = document.createDocumentFragment();
      desired.forEach(card => fragment.appendChild(card));
      grid.appendChild(fragment);
    }
    menu.dataset.shuffled = 'true';
    menu.dataset.pbRandomVersion = '5';
  };
  const scan = () => document.querySelectorAll('.pb-mega-products').forEach(repairMenu);
  const start = () => {
    scan();
    new MutationObserver(scan).observe(document, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'hidden']
    });
    document.addEventListener('shopify:section:load', scan);
    window.addEventListener('pageshow', scan);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
